<script setup lang="ts">
import CardDialog from '@/components/dialogs/CardDialog.vue'
import useServiceStore from '@/store/service'
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

const emit = defineEmits<{
  /** Emitted when user cancels the dialog */
  cancel: []
  /** Emitted when the dialog is closed */
  close: []
}>()

defineOptions({
  name: 'NoBankAccountErrorDialog'
})

const router = useRouter()
const { t } = useI18n()
const serviceStore = useServiceStore()
const { isKyy } = storeToRefs(serviceStore)

const navigateToAccounts = async (): Promise<void> => {
  const route = isKyy.value ? 'bank_account_details' : 'bank_accounts'
  await router.push({ name: route })
  emit('close')
}
</script>

<template>
  <CardDialog
    :title="t('error.no_bank_account')"
    @action="navigateToAccounts"
    @close="$emit('cancel')"
  >
    <p>{{ t('bank_account.error.no_bank_account_desc') }}</p>

    <template #action>
      {{ t('bank_account.error.set_bank_account') }}
    </template>
  </CardDialog>
</template>
